/* eslint-disable */
import {put, takeEvery} from "redux-saga/effects";
import {Project} from "../../models/project";
import {
    GetAllProjectList,
    GetAllProjectListComplete,
    UpdateProject,
    UpdateProjectComplete,
    UpdateProjectFailed,
    filterProjectList,
    filterProjectListComplete,
    AddVideoToProject,
    AddVideoToProjectComplete
} from "../actions/ExProjectActions";
import ProjectApi from "../apis/ExProjectApi";
import ProjectEvents from "../events/ExProjectEvents";

// プロジェクト一覧取得
function* GetAllProjects({userId}: ReturnType<typeof GetAllProjectList>) {
    const projects: Project[] = yield ProjectApi.GetAllProjectList(userId);
    yield put(GetAllProjectListComplete(projects));
}
// プロジェクトフィルター
function* loadfilteredProjectList({userId, filters}: ReturnType<typeof filterProjectList>) {
    console.log("ExProjectSaga: loadfilteredProjectList:", filters)
    const filterResult: Project[] = yield ProjectApi.GetProjectByProfessional(userId, filters);
    console.log("filters : ",filterResult)
    yield put(filterProjectListComplete(filterResult));
}
// プロジェクト一覧更新
function* UpdateProjectWorker({userId, projectList}: ReturnType<typeof UpdateProject>) {
    const result: any = yield ProjectApi.UpdateProject(userId, projectList);
    console.log("ProjectSaga: UpdateProjectWorker:", result)
    if (result.response && result.response.status !== 200) {
        yield put(UpdateProjectFailed(result.stack));
   } else {
        yield put(UpdateProjectComplete(result));
   }
}
// プロジェクトにビデオ（エビソード・関連）を追加
function* AddVideoToProjectWorker({userId, projectId, videoId}: ReturnType<typeof AddVideoToProject>) {
    const project: any = yield ProjectApi.AddVideoToProject(userId, projectId, videoId);
    console.log("ProjectSaga: AddVideoToProjectWorker:", project)
    yield put(AddVideoToProjectComplete(project));
}

export default function* ProjectSaga() {
    yield takeEvery(ProjectEvents.GetAllProjectListStarted, GetAllProjects);
    yield takeEvery(ProjectEvents.filterProjectListStart, loadfilteredProjectList);
    yield takeEvery(ProjectEvents.UpdateProjectStarted, UpdateProjectWorker);
    yield takeEvery(ProjectEvents.AddVideoToProject, AddVideoToProjectWorker);
}
